import type { DirectiveBinding } from 'vue';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<boolean | undefined>) {
    if (binding.value !== false) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
};
